import { useState } from 'react';
import moment from 'moment';
import { Switch } from 'antd';
import { apiRequest } from '../../../api';
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import * as CareerReducer from './CareerReducer';
import { Link } from 'react-router-dom';

export const TableRow = ({ item, index }) => {
    console.log(item);
    const { id, position_name, updatedAt, sku } = item;  
    const date = moment(updatedAt).format('L');
    const time = moment(updatedAt).format('LT');
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const getCareerList = () => {
        apiRequest({
            method: "GET",
            url: "career"
        }).then(resp => {
            dispatch(CareerReducer.actions.careerList(resp.data));
        }).catch(error => {
            dispatch(CareerReducer.actions.careerList([]));
        });
    };

    const handleCheckedClick = () => {
        setLoading(true);
        apiRequest({
            method: 'PUT',
            url: `/career/${id}`,
            data: {
                ...item,
                status: `${item.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'}`
            }
        }).then(() => {
            setLoading(false);
            getCareerList();
        }).catch((error) => {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: error.message,
                width: 400
            });
        })
    }

    const handleDelete = () => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You are about to delete this item.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                apiRequest({
                    method: 'DELETE',
                    url: `/career/${id}`
                }).then(() => {
                    setLoading(false);
                    getCareerList();
                }).catch((error) => {
                    setLoading(false); // Set loading state to false on error
                    Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: error.message,
                        width: 400
                    });
                });
            }
        });
    }


    return (
        <tr>
            <th scope="row">{index + 1}</th>
            <td>{position_name ? position_name : '---'}</td>
            <td>{`${date} ${time}`}</td>
            <td>{item.status}</td>
            <td>{item.updated_by }</td>            
            <td>
                <Link to={`/career/edit/${sku}`}><i className="icon-pencil"></i></Link>
                {
                    loading ? (
                        <span className='indicator-progress'>
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                    ) : (
                        <button type="button" onClick={handleDelete}>
                            <i className="icon-trash"></i>
                        </button>
                    )
                }
            </td>
            {/* <td>
                <span className='mx-1'>Active</span>
                <Switch checked={item.status === 'ACTIVE' ? true : false} onClick={handleCheckedClick} loading={loading} />
                <span className='mx-1'>Inactive</span>
            </td> */}
        </tr>
    )
}
